/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { CSMasterDetailsDto, CSMasterListItemDto, CSMasterListItemStatus } from './cs-master.model';

export const CSMasterMapper = entity<CSMasterListItemDto>({
  statusValue: enumeration(CSMasterListItemStatus),
});
export const CSMasterDetailMapper = entity<CSMasterDetailsDto>({});
